/* eslint max-classes-per-file: 0 */

import {
  Session,
  Session as Collection,
} from '@/typings/api/Session'

import { Fabric } from '@/store/createCrudModule'
import { AgpSessionsApi as Api } from '@/api/resources'


export const fabric = Fabric<Session, Collection>()

type S = SessionsState
type G = SessionsGetters
type M = SessionsMutations
type A = SessionsActions


export class SessionsAdapter extends fabric.Adapter<Api> {
  public readonly api = new Api();
}

export class SessionsState extends fabric.State {
}

export class SessionsGetters extends fabric.Getters<S> {
}

export class SessionsMutations extends fabric.Mutations<S> {
}

export class SessionsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new SessionsAdapter();

  protected readonly idName = 'id';

  public logoutSession({ payload }: { payload: Session }) {
    return this.adapter.api.logout(payload.id)
  }
}
